import mixpanel from "mixpanel-browser"
import { useAuthStore } from "stores"
import { isMixpanelEnabled } from "utils/mixpanel"

export const mixPanelEvent = (
  event: string,
  userId?: string,
  properties?: any
) => {
  // Mixpanel is initialized once at app bootstrap (see initMixpanel /
  // useMixpanelSession). Skip when disabled instead of re-initializing here.
  if (!isMixpanelEnabled) return

  const user = useAuthStore.getState().user

  if (userId || user?.userName) {
    mixpanel.identify(userId || user?.userName)
  }

  const MixPanelProperties = {
    "Organization Id": user?.userOrganisationId,
    "Organization Name": user?.userOrganisation,
    "Is Admin": user?.isAdmin,
    channel: "Web",
    ...properties,
  }

  mixpanel.track(event, MixPanelProperties)
}
